export const CloverRpaWorkflowLoadingOutcome = {
    LOADED: 'loaded',
    MISSING_PACKAGE: 'missing_package',
    MALFORMED_WORKFLOWS: 'malformed_workflows',
} as const;

export type CloverRpaWorkflowLoadingOutcome =
    (typeof CloverRpaWorkflowLoadingOutcome)[keyof typeof CloverRpaWorkflowLoadingOutcome];

export const CloverRpaCapabilityStatus = {
    ENABLED: 'enabled',
    DISABLED: 'disabled',
    UNSUPPORTED: 'unsupported',
} as const;

export type CloverRpaCapabilityStatus =
    (typeof CloverRpaCapabilityStatus)[keyof typeof CloverRpaCapabilityStatus];

export const CloverRpaCapabilityName = {
    CARD_PRESENT_TERMINAL_SALE: 'card_present_terminal_sale',
    CARD_NOT_PRESENT_TOKEN_SALE: 'card_not_present_token_sale',
    STORED_CARD_PAYMENT: 'stored_card_payment',
    TRANSACTION_STATUS_LOOKUP: 'transaction_status_lookup',
    TERMINAL_ABORT: 'terminal_abort',
    TERMINAL_TOKENIZATION: 'terminal_tokenization',
    ACH_PAYMENT: 'ach_payment',
} as const;

export type CloverRpaCapabilityName =
    (typeof CloverRpaCapabilityName)[keyof typeof CloverRpaCapabilityName];

export const CloverRpaWorkflowId = {
    TERMINAL_SALE: 'clover_terminal_sale',
    TERMINAL_ABORT: 'clover_terminal_abort',
    RECORD_CARD_TOKEN: 'clover_record_card_token',
    CNP_TOKEN_SALE: 'clover_cnp_token_sale',
    STORED_CARD_PAYMENT: 'clover_stored_card_payment',
    TRANSACTION_STATUS: 'clover_transaction_status',
    ACH_PAYMENT: 'clover_ach_payment',
} as const;

export type CloverRpaWorkflowId =
    (typeof CloverRpaWorkflowId)[keyof typeof CloverRpaWorkflowId];

export interface CloverEnabledRpaCapability {
    readonly status: typeof CloverRpaCapabilityStatus.ENABLED;
}

export interface CloverDisabledRpaCapability {
    readonly status: typeof CloverRpaCapabilityStatus.DISABLED;
    readonly disabledReason: string;
}

export interface CloverUnsupportedRpaCapability {
    readonly status: typeof CloverRpaCapabilityStatus.UNSUPPORTED;
    readonly unsupportedReason: string;
}

export type CloverRpaCapability =
    | CloverDisabledRpaCapability
    | CloverEnabledRpaCapability
    | CloverUnsupportedRpaCapability;

export type CloverRpaCapabilityMetadata = {
    readonly [CapabilityName in CloverRpaCapabilityName]: CloverRpaCapability;
};

export interface CloverRpaWorkflowLoadingRequestDetails {
    readonly packageName: 'clover-ipg';
    readonly requestedWorkflowIds: readonly CloverRpaWorkflowId[];
}

export interface CloverRpaWorkflowDescriptor {
    readonly id: CloverRpaWorkflowId;
    readonly capabilityName: CloverRpaCapabilityName;
    readonly enabled: boolean;
    readonly showInMenu: boolean;
}

export interface CloverRpaWorkflowLoadingNormalizedResult {
    readonly packageName: 'clover-ipg';
    readonly workflowIds: readonly CloverRpaWorkflowId[];
    readonly loadedWorkflowCount: number;
    readonly enabledWorkflowCount: number;
    readonly capabilities: CloverRpaCapabilityMetadata;
}

export type CloverRpaWorkflowLoadingResponseDetails =
    | {
          readonly outcome: typeof CloverRpaWorkflowLoadingOutcome.LOADED;
          readonly workflows: readonly CloverRpaWorkflowDescriptor[];
          readonly normalizedResult: CloverRpaWorkflowLoadingNormalizedResult;
      }
    | {
          readonly outcome: typeof CloverRpaWorkflowLoadingOutcome.MISSING_PACKAGE;
          readonly packageName: 'clover-ipg';
          readonly message: string;
      }
    | {
          readonly outcome: typeof CloverRpaWorkflowLoadingOutcome.MALFORMED_WORKFLOWS;
          readonly packageName: 'clover-ipg';
          readonly message: string;
          readonly workflowIds?: readonly string[];
      };
